import React, { Component } from 'react';

import Button from '../../UI/Button';
import { Textarea } from '../../UI/Input';

import { Modal } from 'antd';

class AddCommentModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      comment: this.props.comment,
    };
  }

  updateComment = (e) => {
    this.setState({
      ...this.state,
      comment: e.target.value,
    });
  }

  render() {
    return (
      <Modal
        visible={this.props.open}
        title="Opmerking toevoegen"
        footer={[
          <Button key="back" size="large" onClick={this.props.onClose}>
            Annuleren
          </Button>,
          <Button
            key="submit"
            type="primary"
            size="large"
            onClick={() => {
              this.props.onConfirm(this.state.comment);
            }}
          >
            Bevestigen
          </Button>,
        ]}
      >
        <Textarea autosize={{ minRows: 10, maxRows: 20}} placeholder="Noteer hier uw opmerking" defaultValue={this.props.comment} onChange={this.updateComment} />
      </Modal>
    );
  }
}

export default AddCommentModal;


// WEBPACK FOOTER //
// ./src/components/Orders/Modals/AddCommentModal.js